/* eslint-env browser */

(function (window, document) {
    const preloadStore = window.__gdArticleImagePreloads = window.__gdArticleImagePreloads || [];

    function preloadImage(image) {
        const src = image.currentSrc || image.getAttribute('src');
        const srcset = image.getAttribute('srcset');

        if (!src && !srcset) {
            return;
        }

        image.loading = 'eager';

        if (!image.hasAttribute('decoding')) {
            image.decoding = 'async';
        }

        if ('fetchPriority' in image && !image.hasAttribute('fetchpriority')) {
            image.fetchPriority = 'low';
        }

        const preloaded = new Image();
        preloaded.decoding = 'async';

        if ('fetchPriority' in preloaded) {
            preloaded.fetchPriority = 'low';
        }

        const sizes = image.getAttribute('sizes');

        if (sizes) {
            preloaded.sizes = sizes;
        }

        if (srcset) {
            preloaded.srcset = srcset;
        }

        if (src) {
            preloaded.src = src;
        }

        preloadStore.push(preloaded);
    }

    function preloadArticleImages() {
        const articleBody = document.querySelector('[data-gd-preload-article-images]');

        if (!articleBody) {
            return;
        }

        articleBody.querySelectorAll('img').forEach(preloadImage);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', preloadArticleImages, {once: true});
    } else {
        preloadArticleImages();
    }
})(window, document);
